import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import SearchForm from "@Filters/SearchForm";
import { Link } from "react-router-dom";

function BranchFilters({intl, searchParams, regionList, specialismOptions, appConfigs, resultsTotal}) {
  const searchFormSubmit = useRef();
  const filtersPopup = useRef();

  const closeMobileFilter = () => {
    const body = document.getElementsByTagName("body");

    body[0].classList.remove("filter-active");
    filtersPopup.current.classList.remove("filter__content--active");
  };

  const mobileSubmit = (event) => {
    event.preventDefault();
    closeMobileFilter();

    searchFormSubmit.current.click();
  }

  return (
    <>
      <div className="filter" data-rs-filter={true}>
        <div className="filter__toggle" data-rs-filter-refine-search={true} role="button" aria-label="">
          <span className="icon icon--inline hidden--from-l text-brand-primary">
            <svg>
              <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#filter"/>
            </svg>
          </span>
          <span>{ intl.formatMessage({id: "BranchFilters.FilterTitle"}) }</span>
        </div>
        <div className="filter__content" data-rs-filter-content={true} ref={filtersPopup}>
          <div className="filter__header hidden--from-l">
            <div className="filter__title">
              { intl.formatMessage({id: "BranchFilters.FilterTitleMobile"})}
            </div>
            <span className="icon icon--inline">
              <svg data-rs-filter-close={true}>
                <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#close"/>
              </svg>
            </span>
          </div>
          <div className="filter__block">
            <SearchForm searchParams={searchParams} regionList={regionList} specialismOptions={specialismOptions} searchSubmitRef={searchFormSubmit}/>
          </div>
          <div className="filter__footer divider divider--top hidden--from-l">
            <Link to="#" className="button button--full-width button--filled" onClick={mobileSubmit}>
              {
                resultsTotal ?
                  intl.formatMessage({id: "BranchFilters.ShowResults"}, {total: resultsTotal}) :
                  intl.formatMessage({id: "BranchFilters.NoResults"})
              }
            </Link>
          </div>
        </div>
        <div className="seo-content text--alternative">
          { appConfigs && appConfigs.text_below_filters ? appConfigs.text_below_filters : intl.formatMessage({id: "BranchFilters.SeoText"}) }
        </div>
      </div>
    </>
  )
}

export default injectIntl(BranchFilters);